export enum ProviderType {
  NONE = "none",
  WEB3 = "web3",
  RPC = "rpc",
}
